module.exports = __webpack_public_path__ + "static/media/arbreFond.4d065e52.png";